import { render, staticRenderFns } from "./course-modal.vue?vue&type=template&id=7b195c3f&"
import script from "./course-modal.vue?vue&type=script&lang=js&"
export * from "./course-modal.vue?vue&type=script&lang=js&"
import style0 from "./course-modal.vue?vue&type=style&index=0&id=7b195c3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports